module.exports = __webpack_public_path__ + "img/check.76b6a05f.png";